export const MULTIPLE_FILTER_VALUE_SEPARATOR = '/';
